module.exports = __webpack_public_path__ + "static/img/KH.513cd27f.svg";